import {BmCardViewSection} from "~/components/templates";
import {BmUnstyledSvgButton} from "~/components/buttons";
import {BmCloseIcon} from "~/components/icons/simpleIcons";
import {BmCommonTitle} from "~/components/titles";

import {IModalContent} from "../IModalContent";

export const BmCardViewModalContent: React.FC<IModalContent> = ({
  title,
  subtitle,
  showDivider,
  closeButton,
  onClose,
  children,
}) => {
  return (
    <BmCardViewSection
      title={<BmCommonTitle sx={{mb: 0}}>{title}</BmCommonTitle>}
      titleRight={
        closeButton ? (
          <BmUnstyledSvgButton id="close-modal-button" onClick={onClose}>
            <BmCloseIcon id="close-modal-icon" />
          </BmUnstyledSvgButton>
        ) : undefined
      }
      subtitle={subtitle}
      showDivider={showDivider}
    >
      {children}
    </BmCardViewSection>
  );
};
